import { LoadMarketCard } from "../../../services/load/useGetLoadMarketV2/type";
import { IEventTrackerProp } from "../../../types/events";

export enum COMPACT_LOAD_BIDDING_STEPS {
    BID_DETAILS = "bidDetails",
    LOGIN = "login",
    SUCCESS = "success",
    ERROR = "error"
}

export interface CompactBiddingState {
    loadData: LoadMarketCard;
    bidAmount?: number;
    consentAccepted?: boolean;
    bidId?: number;
    useCoins?: boolean;
}

export interface CompactLoadBiddingModalProps extends IEventTrackerProp {
    isOpen: boolean;
    loadData: LoadMarketCard;
    onClose: () => void;
    onSuccess?: () => void;
    trackRank?: number;
}
